import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/jensen-alpha-calculator',
  component: () => import('../../routes/JensenAlphaCalculator.svelte'),
  card: {
    id: 'jensen-alpha-calculator',
    title: "Jensen's Alpha Calculator",
    description:
      "Calculate Jensen's Alpha to measure risk-adjusted portfolio performance vs. CAPM-predicted return. Identifies whether a manager adds value beyond what systematic risk alone would predict.",
    icon: 'analytics',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/jensen-alpha-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: "Jensen's Alpha Calculator – Risk-Adjusted Portfolio Performance",
    description:
      "Free Jensen's Alpha calculator. Quantifies how much a portfolio outperformed or underperformed its CAPM-predicted return. Includes market risk premium, expected return, and performance classification (strong/modest/significant out- or underperformance).",
  },
};

export default meta;
